module.exports = __webpack_public_path__ + "static/about-363071ffdb6ce888b17a80f367e4fab9.jpg";